// Relative to the axios base URL, which already appends /api (src/utils/axios.ts).
export const BULK_ORDER_OPERATIONS_ENDPOINTS = {
	execute: "BulkOrderOperations/execute",
	// History Management category — per-record CRUD on one order's StatusHistory.
	orderHistory: (orderId: number) => `BulkOrderOperations/history/${orderId}`,
	responsibleUsers: "BulkOrderOperations/history/responsible-users",
	addHistory: "BulkOrderOperations/history",
	deleteHistory: (historyId: number) =>
		`BulkOrderOperations/history/${historyId}`,
	// Section ID category — batch, but driverless, so it does not go through `execute`.
	setSectionId: "BulkOrderOperations/section",
	// Bulk Status Updates category — preflight classifies the batch, then execute applies it.
	statusUpdatePreflight: "BulkOrderOperations/status/preflight",
	statusUpdate: "BulkOrderOperations/status",
	// Duplicate Payments category — search a date window, then delete one order's extra rows.
	duplicatePayments: "BulkOrderOperations/duplicate-payments",
	deleteDuplicatePayments: (orderId: number) =>
		`BulkOrderOperations/duplicate-payments/${orderId}`,
} as const;
